import {
  NON_SFDC_FIELDS,
  TODAY_AND_N_DAYS,
  TODAY_AND_N_WEEKDAYS,
  CUSTOM_SCHEDULER_LINK,
} from '@groove/api/helpers/nonSFDCfields';
import { MergeField } from '@groove/ui/type';

import { MergeFieldGroup } from '.';

export const isCustomMergeField = (mergeField: MergeField): boolean => {
  return NON_SFDC_FIELDS.options.some(
    option => option.name === mergeField.name,
  );
};

export const isCustomMergeFieldWithDays = (mergeField: MergeField): boolean => {
  return (
    mergeField.name === TODAY_AND_N_DAYS ||
    mergeField.name === TODAY_AND_N_WEEKDAYS
  );
};

export const MAX_DAYS: Record<string, number> = {
  [TODAY_AND_N_DAYS]: 6,
  [TODAY_AND_N_WEEKDAYS]: 5,
};

export const isCustomSchedulerLink = (mergeField: MergeField): boolean =>
  mergeField.name === CUSTOM_SCHEDULER_LINK;

export const removeNonSFDCMergeFields = (
  mergeFields: MergeFieldGroup[],
): MergeFieldGroup[] => {
  return mergeFields.filter(field => field.label !== NON_SFDC_FIELDS.label);
};
